import React, { FC } from 'react';
import { Box, Typography, AppBar } from '@mui/material';

const NotFoundPage: FC = () => {
  const isLoggedInSession = localStorage.getItem('idToken');
  return (
    <Box>
      {isLoggedInSession === undefined && (
        <AppBar
          position="sticky"
          data-testid="welcome-top-bar"
          sx={{ width: '100%', zIndex: (theme) => theme.zIndex.drawer + 1, textAlign: 'center' }}
        >
          <Typography variant="h3" data-testid="jimbo-title">
            Jimbo
          </Typography>
        </AppBar>
      )}

      <Box marginTop={2} data-testid="not-found-page" textAlign="center">
        <Typography variant="h3">404 Not Found</Typography>
      </Box>
    </Box>
  );
};

export default React.memo(NotFoundPage);
